export default __webpack_public_path__ + "static/media/brgy_logo.f2e74052.png";